import { FullscreenOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import {
  setAnalysisImageId,
  setAnalysisWorkId,
  setSelectedPage
} from '@/features/SetAnalysisImageInfo/setAnalysisImageInfo'
import {
  setCompareImageId,
  setCompareWorkId
} from '@/features/SetCompareImageInfo/setCompareImageInfo'
import { setShowType } from '@/features/SetCompareInfo/setCompareInfo'
import { useAppDispatch } from '@/hooks'
import { SRC_URL } from '@/server'

const ChuanyiThumbnail = (props) => {
  const dispatch = useAppDispatch()
  const setShowPanel = props.setShowPanel
  const compareImgs = props.similarImgsInfo

  return (
    <div className='chuanyi-thumbnail-panel'>
      <div className='chuanyi-thumbnail-title'>
        <h2>传移模写</h2>
        <FullscreenOutlined
          className='chuanyi-thumbnail-button'
          onClick={() => {
            setShowPanel(1)
          }}
        />
      </div>
      <div className='chuanyi-thumbnail-pictures'>
        {compareImgs.map((item) => {
          return (
            <div className='chuanyi-thumbnail-eachPicture' key={item.imgSrc}>
              <Tooltip
                overlayStyle={{ maxWidth: 1920 }}
                title={
                  <div>
                    <button
                      className='chuanyi-compareImgButton'
                      onClick={() => {
                        dispatch(setAnalysisImageId(item.imageId))
                        dispatch(setAnalysisWorkId(item.workId))
                      }}
                    >
                      画作分析
                    </button>
                    <button
                      className='chuanyi-compareImgButton'
                      onClick={() => {
                        dispatch(setCompareImageId(item.imageId))
                        dispatch(setCompareWorkId(item.workId))
                        dispatch(setSelectedPage(2))
                        dispatch(setShowType(2))
                      }}
                    >
                      画作对比
                    </button>
                  </div>
                }
                trigger='click'
              >
                <img
                  className='chuanyi-thumbnail-eachPicture-picture'
                  src={item.imgSrc ? SRC_URL + item.imgSrc : ''}
                  alt=''
                ></img>
              </Tooltip>
              <div>{item.title}</div>
              <div>{item.author}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ChuanyiThumbnail
